import c3 from 'c3';

const WORK_COLOR_PALET = ['#97a6db', '#fbf088', '#c1f5b1', '#78e2d2', '#bae6f9', '#fff5c1', '#f29bc1', '#bff7ef'];
const FAMILY_AND_SHARES_DATA = window.familyAndShares;
const TOOLTIP_TPL = $('#tooltipFreelanceWorkTemplate').html();
const DEFAULT_CHART_OPTION = {
    data: {
        type: 'pie',
    },
    size: {
        width: 350,
        height: 350,
    },
    legend: {
        show: false,
    },
    color: {
        pattern: WORK_COLOR_PALET,
    },
    pie: {
        label: {
            show: false,
        },
    },
    tooltip: {
        contents: (data) => {
            const key = data[0].name;
            const value = data[0].value;
            return Hop.template(TOOLTIP_TPL, {variable: 'm'})({key, value});
        },
    },
};

if (window.matchMedia('(max-width:767px)').matches) {
    DEFAULT_CHART_OPTION.tooltip.position = () => {
        return {top: 0, left: 0}; // fix tooltip outside of screen issue
    };
}

Hop.defineModule('freelancer-work-stats', (domRoot) => {
    function createFamilyAndSharesChart() {
        const familyAndSharesChartOptions = DEFAULT_CHART_OPTION;
        familyAndSharesChartOptions.bindto = '#familyAndShares';
        familyAndSharesChartOptions.data.columns = FAMILY_AND_SHARES_DATA;
        c3.generate(familyAndSharesChartOptions);
    }

    function colorizeLegend() {
        domRoot.querySelectorAll('.barometer-legend__color').forEach((el, idx) => {
            el.style.backgroundColor = WORK_COLOR_PALET[idx];
        });
    }

    createFamilyAndSharesChart();
    colorizeLegend();
});
